import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CreateTaskGroupCommand, TaskGroupType, UpdateTaskGroupCommand } from '../state/types';
import { BLService } from './bl.service';

@Injectable({ providedIn: 'root' })
export class TaskGroupService extends BLService {
  private RESOURCE_ENDPOINT = 'taskgroup';

  getTaskGroups(): Observable<TaskGroupType[]> {
    return this.httpGet<TaskGroupType[]>(this.RESOURCE_ENDPOINT);
  }

  createTaskGroup(createTaskGroup: CreateTaskGroupCommand): Observable<TaskGroupType> {
    return this.httpPost<TaskGroupType>(this.RESOURCE_ENDPOINT, createTaskGroup);
  }

  updateTaskGroup(id: number, updateTaskGroup: UpdateTaskGroupCommand): Observable<TaskGroupType> {
    const url = `${this.RESOURCE_ENDPOINT}/${id}`;
    return this.httpPatch<TaskGroupType>(url, updateTaskGroup).pipe(this.catchErrorAndShowMessage());
  }

  deleteTaskGroup(id: number): Observable<void> {
    return this.httpDelete<void>(`${this.RESOURCE_ENDPOINT}/${id}`);
  }
}
